export const isTestABVersion = () => !!document.getElementById('vwoCode');

export const isBVersion = () => window.sessionStorage.getItem('vwo_test_ab') === 'true';
